import { CATEGORIES } from './constants'

export type RequestStatus =
  | 'pending'
  | 'in-progress'
  | 'completed'
  | 'cancelled'

export interface ServiceRequest {
  id: string
  categoryId: string
  categoryName: string
  issue: string
  status: RequestStatus
  date: string
  location: string
}

const getCategoryName = (id: string) =>
  CATEGORIES.find((c) => c.id === id)?.name || 'Service'

export const MOCK_REQUESTS: ServiceRequest[] = [
  {
    id: 'REQ-1001',
    categoryId: 'aircon',
    categoryName: 'Aircon',
    issue: 'Aircon leaking water and not cooling properly in master bedroom.',
    status: 'pending',
    date: '2023-10-25T09:30:00',
    location: 'Mont Kiara, KL',
  },
  {
    id: 'REQ-1002',
    categoryId: 'plumbing',
    categoryName: 'Plumbing',
    issue: 'Kitchen sink pipe burst, water flooding the floor.',
    status: 'in-progress',
    date: '2023-10-24T14:15:00',
    location: 'Bangsar, KL',
  },
  {
    id: 'REQ-1003',
    categoryId: 'electrical',
    categoryName: 'Electrical',
    issue: 'Power trip whenever I turn on the water heater.',
    status: 'completed',
    date: '2023-10-22T10:00:00',
    location: 'Cheras, KL',
  },
  {
    id: 'REQ-1004',
    categoryId: 'washing-machine',
    categoryName: 'Washing Machine',
    issue: 'Machine making loud banging noise during spin cycle.',
    status: 'pending',
    date: '2023-10-20T16:45:00',
    location: 'Setapak, KL',
  },
  {
    id: 'REQ-1005',
    categoryId: 'handyman',
    categoryName: 'Handyman',
    issue: 'Need help assembling IKEA wardrobe and bookshelf.',
    status: 'completed',
    date: '2023-10-18T11:20:00',
    location: 'Ampang, KL',
  },
  {
    id: 'REQ-1006',
    categoryId: 'water-heater',
    categoryName: 'Water Heater',
    issue: 'No hot water coming out, indicator light not turning on.',
    status: 'cancelled',
    date: '2023-10-15T08:50:00',
    location: 'Kepong, KL',
  },
  {
    id: 'REQ-1007',
    categoryId: 'aircon',
    categoryName: 'Aircon',
    issue: 'General chemical cleaning for 3 units.',
    status: 'completed',
    date: '2023-10-12T13:00:00',
    location: 'TTDI, KL',
  },
  {
    id: 'REQ-1008',
    categoryId: 'refrigerator',
    categoryName: 'Refrigerator',
    issue: 'Freezer is working but fridge compartment is warm.',
    status: 'in-progress',
    date: '2023-10-10T09:15:00',
    location: 'Sri Petaling, KL',
  },
  {
    id: 'REQ-1009',
    categoryId: 'tv-appliance',
    categoryName: 'TV / Home Appliance',
    issue: 'TV screen flickering and sound cutting out.',
    status: 'pending',
    date: '2023-10-08T19:30:00',
    location: 'Wangsa Maju, KL',
  },
  {
    id: 'REQ-1010',
    categoryId: 'plumbing',
    categoryName: 'Plumbing',
    issue: 'Toilet bowl clogged, plunger not working.',
    status: 'completed',
    date: '2023-10-05T15:45:00',
    location: 'Bukit Jalil, KL',
  },
  {
    id: 'REQ-1011',
    categoryId: 'electrical',
    categoryName: 'Electrical',
    issue: 'Install new ceiling fan in living room.',
    status: 'completed',
    date: '2023-10-03T10:30:00',
    location: 'Sentul, KL',
  },
  {
    id: 'REQ-1012',
    categoryId: 'handyman',
    categoryName: 'Handyman',
    issue: 'Fix loose cabinet hinges in kitchen.',
    status: 'pending',
    date: '2023-10-01T14:00:00',
    location: 'Desa ParkCity, KL',
  },
]
